import ComparisonButton from './ComparisonButton';

export default ComparisonButton;